export function ConvertNullInt(str) {
  if (str == "null") return null;
  else return parseInt(str);
}
